import {
  app_sections,
  app_section_ids,
  SECTION_STATUS,
  APPLICATION_STATUSES,
} from '../../constants/application';

export const getNavigationSections = (application) => {
  if (application) {
    console.log(application);
  }
  return app_sections.map((section, index) => ({
    ...app_sections[index],
    status: SECTION_STATUS.NOT_STARTED,
    disabled: index > 0,
  }));
};

const getSectionComplete = (name, sections) => {
  try {
    return sections.find((section) => section.name === name).isComplete;
  } catch {
    return false;
  }
};

export const isSectionDisabled = (
  name,
  sections,
  applicationStatus,
  isQuoteEditable,
  isPortalQuote
) => {
  console.log('isPortalQuote', isPortalQuote);
  // disable all tabs if status is on risk
  if (applicationStatus === APPLICATION_STATUSES.WENT_ON_RISK) return true;
  switch (name) {
    case app_section_ids.CLIENT_DETAILS: {
      return (
        applicationStatus === APPLICATION_STATUSES.UNDERWRITING ||
        isQuoteEditable === false ||
        isPortalQuote === true
      );
    }
    case app_section_ids.QUOTE: {
      return (
        !getSectionComplete(app_section_ids.CLIENT_DETAILS, sections) ||
        applicationStatus === APPLICATION_STATUSES.UNDERWRITING ||
        isQuoteEditable === false ||
        isPortalQuote === true
      );
    }
    case app_section_ids.CONTACT_DETAILS: {
      return (
        !getSectionComplete(app_section_ids.CLIENT_DETAILS, sections) ||
        applicationStatus === APPLICATION_STATUSES.UNDERWRITING
      );
    }
    case app_section_ids.UNDERWRITING: {
      if (
        getSectionComplete(app_section_ids.UNDERWRITING, sections) &&
        applicationStatus !== APPLICATION_STATUSES.UNDERWRITING &&
        isPortalQuote !== true
      ) {
        return false;
      }
      return (
        !getSectionComplete(app_section_ids.QUOTE, sections) ||
        applicationStatus !== APPLICATION_STATUSES.APPLY ||
        isPortalQuote === true
      );
    }
    case app_section_ids.AMRA: {
      return (
        !getSectionComplete(app_section_ids.QUOTE, sections) ||
        applicationStatus === APPLICATION_STATUSES.UNDERWRITING
      );
    }
    case app_section_ids.DECISION: {
      return !getSectionComplete(app_section_ids.UNDERWRITING, sections);
    }
    case app_section_ids.SETUP: {
      return (
        !getSectionComplete(app_section_ids.CLIENT_DETAILS, sections) ||
        applicationStatus === APPLICATION_STATUSES.UNDERWRITING
      );
    }
    default:
      return false;
  }
};
